<template>
    <div class="font-monospace font-normal text-16 md:text-24 lg:text-32" :class="{ 'text-gray-200': !isRunning }">
      {{ secondsElapsed | timeElapsed }}
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    export default {
      name: 'Timer',

      props: ['timerId', 'isRunning'],

      data () {
        return {
          interval: null
        }
      },

      methods: {
        start () {
          const component = this
          this.interval = setInterval(function () {
            component.$store.commit('increaseTimer', { timerId: component.timerId })
          }, 1000)
        },

        stop () {
            clearInterval(this.interval)
        }
      },

      beforeDestroy () {
        this.stop()
      },

      watch: {
        isRunning: {
          handler: function (newValue) {
            if (newValue) {
              this.start()
            } else {
              this.stop()
            }
          },
          immediate: true
        }
      },

      computed: {
        ...mapState({
          timers: state => state.timers
        }),

        secondsElapsed () {
          return this.timers[this.timerId]
        }
      }
    }
</script>